import dayjs from "dayjs"
import Loading from "../../components/Common/Loading";
import {DataGridPro} from "@mui/x-data-grid-pro";
import {useGetPaymentsV1TOHQuery} from "../../core/api/toh-analytical-data-api";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {useState} from "react";
import TohPurchaseItem from "../Analytics/toh/TohPurchaseItem";

const PaymentsTOH = (props) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetPaymentsV1TOHQuery(props.deviceId)

    let payments = ""
    const [state, setState] = useState({
        showDetails: false,
        selectedPayload: '',
        selectedDate: ''
    })

    const handleViewDetails = (item) => {
        setState({
            ...state,
            showDetails: true,
            selectedPayload: item.payload,
            selectedDate: item.timestamp
        })
    }

    const columns = [
        {
            field: 'action',
            headerName: 'Purchases',
            renderCell: (params) => {
                // Assuming isAdmin is available in the component's scope
                return <IconButton
                    aria-label="edit"
                    onClick={() => handleViewDetails(params.row)}
                >
                    <SearchIcon />
                </IconButton>
            },
            sortable: false,
            filterable: false,
        },
        {
            label: 'Currency',
            field: 'currency',
            width: 70
        },
        {
            label: 'UsdCents',
            field: 'price',
            flex:1,
        },
        {
            headerName: 'Purchase Network',
            field: 'purchaseNetwork',
            width: 120
        },
        {
            headerName: 'Transaction ID',
            field: 'transactionId',
            flex:1,
        },
        {
            label: 'S Transaction ID',
            field: 'sTransactionId',
            flex:1,
            valueGetter: (value) => value ? value : "-"
        },
        {
            headerName: 'Transaction Time',
            field: 'transactionTime',
            flex:1,
            valueGetter: (value) => value ? dayjs(value).format("DD.MM.YYYY HH:mm:ss.SSS") : "-"
        },
        {
            headerName: 'Timestamp',
            field: 'timestamp',
            flex:1,
            valueGetter: (value) => value ? dayjs(value).format("DD.MM.YYYY HH:mm:ss.SSS") : "-"
        },
        {
            label: 'Store ID',
            field: 'storeId',
            flex:1,
        },
        {
            label: 'Category',
            field: 'category',
            flex:1,

        },
        {
            label: 'Item',
            field: 'item',
            flex:1,

        },
        {
            headerName: 'Is test payment',
            field: 'sourceTable',
            width: 150,
            renderCell: (params) => {
                return params.value==='payments_test'?'TEST':''
            }
        }
    ]

    if (typeof data === "object") {
        payments = <DataGridPro
            getRowId={(row) => row.transactionId+row.transactionTime}
            getRowHeight={() => "auto"}
            rows={data}
            columns={columns}

            getRowClassName={(params) =>
                params.row.sourceTable === 'payments_test' ? 'payments-test-row' : ''
            }

        />
    } else {
        payments = "no data"
    }

    return (
        <>
            <Loading
                isLoading={isLoading||isFetching}
                isError={isError}
                error={error}
                isSuccess={isSuccess}
            >
                {payments}

            </Loading>
            {state.showDetails &&
                <Dialog
                    maxWidth={"xl"}
                    fullWidth={true}
                    scroll={"paper"}
                    open={state.showDetails}
                    onClose={() => setState({
                        ...state,
                        showDetails: false
                    })}>
                    <DialogTitle></DialogTitle>
                    <DialogContent dividers={true}>
                        <TohPurchaseItem deviceId={props.deviceId}
                                         payload={state.selectedPayload}
                                         date={state.selectedDate}/>
                    </DialogContent>
                    <DialogActions>

                        <Button variant="outlined"
                                onClick={() => setState({
                                    ...state,
                                    showDetails: false
                                })}>
                            Close
                        </Button>

                    </DialogActions>


                </Dialog>}
        </>
    )
}

export default PaymentsTOH
